import { configOption, KahunConfigurationOptionType } from "../lib/annotations";

export type CustomFeedbackSubOption = {
  id: string;
  text: string;
  value?: boolean;
}

export interface CustomFeedbackOption {
  id: string;
  text: string;
  value?: boolean;
  subTitleIfTrue?: string;
  subOptionsIfTrue?: CustomFeedbackSubOption[];
  subTitleIfFalse?: string;
  subOptionsIfFalse?: CustomFeedbackSubOption[];
}

export enum suggestedQuestionOption {
    "Never"= "Never",
    "A/B testing" = "A/B testing",
    "Always" = "Always",
}
export class DialogueOptions {
  @configOption({
    description: "Show the Dialogue chatbot in the patient card",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  enabled: boolean = false;

  @configOption({
    description: "Use Dialogue to generate Assessment/Plan/DD (activated by the client)",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  useDialogueForInsights?: boolean;

  @configOption({
    description: "Suggest questions to the user in the chat",
    displayType: KahunConfigurationOptionType.Choice,
    options: suggestedQuestionOption,
  })
  showSuggestedQuestions: suggestedQuestionOption = suggestedQuestionOption.Always;

  @configOption({
    description: "Show chat history",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showChatHistory: boolean = true;

  @configOption({
    description: "Show feedback buttons",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showFeedbackButtons: boolean = true;

  @configOption({
    description: "Custom feedback option in JSON format",
    displayType: KahunConfigurationOptionType.JSON,
  })
  customFeedbackOptions: CustomFeedbackOption[];
}